var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{staticClass:"currency-select",class:{ dense: _vm.dense },attrs:{"value":_vm.value,"label":"Currency","items":_vm.currencies,"item-text":_vm.displayCurrency,"item-value":"code","dense":"","outlined":"","hide-details":""},on:{"change":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }